// ServiceDetails.js
import React, { useEffect, useRef } from 'react';
import HeaderInner from '../header/HeaderInner';
import BreadcrumbSd from '../inner/breadcrumb/BreadcrumbSd';
import Footer from '../elements/Footer';
import { FaCheckCircle } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './ServiceDetails.css';
import { useLocation, useNavigate } from 'react-router-dom';

function ServiceDetails() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const navigate = useNavigate();
  const location = useLocation();

  // Define refs for scroll targets
  const refs = {
    "#accounting": useRef(null),
    "#audit": useRef(null),
    "#setup": useRef(null),
    "#performance": useRef(null),
    "#erp": useRef(null),
    "#merger": useRef(null),
    "#outsourced": useRef(null),
    "#vat": useRef(null),
    "#corporate": useRef(null)
  };

  // Scroll to section when hash changes
  // ServiceDetails.js

// Scroll to section when hash changes
useEffect(() => {
  if (location.hash && refs[location.hash]) {
    setTimeout(() => {
      const el = refs[location.hash].current;
      if (el) {
        const headerOffset = 170; // header height
        const y = el.getBoundingClientRect().top + window.scrollY - headerOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }, 400);
  }
}, [location]);


  const contentBlocks = [
    {
      title: "Accounting & Financial Advisory",
      subtitle: "Financial Clarity Fuels Business Growth",
      key: "#accounting",
      desc: "The accounting function is essential to the success and stability of any organization. It lays the foundation for informed decision-making and long-term growth. Our team supports businesses by ensuring accurate and timely bookkeeping, providing training and oversight for accounting staff, and establishing effective monitoring systems. We bring proven strategies to enhance the performance and impact of your accounting department.",
      points: [
        "Structuring and implementing tailored accounting systems",
        "Creating and executing effective Standard Operating Procedures (SOPs)",
        "Mentoring and overseeing in-house accounting teams",
        "Offering strategic financial leadership through part-time CFO services"
      ],
      img: "assets/images/services/service.jpg"
    },
    {
      title: "Audit & Assurance",
      subtitle: "Audit of Financial statements",
      key: "#audit",
      desc: "Auditing financial statements is often required to comply with various regulatory or organizational needs. We support clients in meeting these requirements efficiently and accurately. Our audit associates are recognized by major banks and free zones across Bahrain, ensuring smooth processes and reliable outcomes.",
      points: [
        "Statutory audits",
        "Tax and VAT compliance",
        "Legal or court-related documentation",
        "Internal management or stakeholder requests",
        
      ],
      img: "assets/images/services/service2.jpg"
    },
    {
      title: "Business Setup Services",
      subtitle: "Business Setup Services",
      key: "#setup",
      desc: "Starting a new company in Bahrain is an exciting step — and having a professional, experienced partner makes the process smooth and stress-free. We assist clients throughout the company formation process, guiding them in choosing the right setup and determining the most suitable location based on business needs.",
      points: [
        "Guidance on company structure (sole establishment, partnership, LLC)",
        "Location assessment (Mainland vs Free Zone)",
        "Comprehensive understanding of Bahrain's legal and regulatory environment",
        "Tax optimization during setup phase",
        "End-to-end company registration support"
      ],
      img: "assets/images/services/service3.jpg"
    },
    {
      title: "Business Performance Review",
      subtitle: "Know where your business stands",
      key: "#performance",
      desc: "Not every business in Bahrain can afford a full-time in-house analyst team — but monitoring performance, growth, and liquidity is still essential. Our experienced team specializes in conducting business performance reviews and providing clear, insightful reports on key financial and operational indicators. With periodic reviews, we help managements stay informed and make data-driven decisions",
      points: [
        "Cash flow analysis and liquidity assessment",
        "Business performance & growth tracking",
        "Key financial ratios analysis",
        "Product margins & inventory turnover evaluation",
        "Break-even analysis",
        "Departmental/product-level profitability assessment",
        "Customer segmentation analysis",
        "Return on investment (ROI) calculations"
      ],
      img: "assets/images/services/service9.jpg"
    },
    {
      title: "ERP Consulting",
      subtitle: "We help you find the ERP solution that fits — perfectly.",
      key: "#erp",
      desc: "Choosing the right ERP or accounting software at the right cost can be a major challenge. A poor selection or faulty implementation can disrupt daily operations and affect long-term efficiency. With our knowledge of successful ERP systems in Bahrain, we guide organizations in selecting and implementing solutions tailored to their size, industry, and specific needs.",
      points: [
        "Recommending the most suitable ERP/accounting software based on your business size, operation, and goals",
        "Advising on organizational structure and process flow, and internal controls during ERP customization",
        "Supporting user training and managing user-related issues",
        "Ensuring smooth and effective implementation process",
        
      ],
      img: "assets/images/services/service4.jpg"
    },
    {
      title: "Merger & Acquisition",
      subtitle: "Unlocking Investment Opportunities",
      key: "#merger",
      desc: "Some organizations seek investors, while investors look for promising opportunities. Successful deals require the right matchmaker to connect the parties, build trust, and unlock value. Leveraging our extensive network, we help businesses find and engage with the right investors or buyers.",
      points: [
        "Identifying and shortlisting potential buyers or investors based on merit and fit",
        "Facilitating discussions and meetings on behalf of both sellers and buyers",
        "Managing all activities to ensure a smooth, efficient, and hassle-free transaction ",
        
      ],
      img: "assets/images/services/service5.jpg"
    },
    {
      title: "Outsourced Accounting",
      subtitle: "Outsourced Accounting",
      key: "#outsourced",
      desc: "Accurate and well-maintained books are the backbone of any successful business. We offer tailored outsourcing solutions for businesses that prefer external expertise or have manageable transaction volumes that don't require a full-time team.",
      points: [
        "Innovative accounting processes that save you time, effort, and costs",
        "Cloud-based accounting systems accessible anytime, anywhere via the internet",
        "Timely finalization of accounts on a monthly or quarterly basis",
        "User-friendly mobile apps providing real-time performance reports",
        "Management of your books by trained and qualified professional accountants",
        "Utilization of leading cloud platforms like Zoho Books, Xero, and QuickBooks Online"
      ],
      img: "assets/images/services/service7.jpg"
    },
    {
      title: "VAT Consulting",
      subtitle: "VAT Consulting Services in Bahrain",
      key: "#vat",
      desc: "Value-Added Tax (VAT) has become a key part of Bahrain's business environment, creating new regulatory responsibilities for companies. Navigating VAT compliance can be complex, so partnering with the right VAT consultant is crucial for ensuring your business meets all legal requirements smoothly and efficiently.",
      points: [
        "Assessing VAT applicability and eligibility",
        "Handling VAT registration and obtaining VAT registration numbers",
        "Implementing and training on smart accounting software for VAT compliance",
        "Evaluating working capital needs and payment cycles under the VAT regime",
        "Advising on VAT treatment for individual transactions and training staff on legal compliance",
        "Calculating VAT liabilities and managing timely VAT return filings "
      ],
      img: "assets/images/services/service8.jpg"
    },
    {
      title: "Corporate Tax Services",
      subtitle: "Corporate Tax Services in Bahrain",
      key: "#corporate",
      desc: "Bahrain has introduced Corporate Tax as part of its evolving tax framework, applying a standard rate of 10% on taxable income for most businesses, with certain exceptions. Calculations and compliance must align with Bahrain's tax laws and regulations. Special provisions apply to companies operating in Baharin's Free Zones, which may benefit from tax incentives if they meet specific conditions",
      points: [
        "Assessing tax applicability and advising on processes and systems",
        "Assisting with tax registration and obtaining the Tax Registration Number (TRN)",
        "Training your team and implementing tax compliance software",
        "Providing guidance on tax obligations and Free Zone-specific provisions",
        "Supporting VAT liability calculation and return filing",
        
      ],
      img: "assets/images/services/service10.jpg"
    }
  ];

  return (
     <div className="service-details">
      <HeaderInner />
      <main>
        <BreadcrumbSd />
        <div style={{ marginTop: "20px" }} className="tmp-service-section">
          <div className="container">
            <div className="row mb-5" data-aos="fade-up">
              <div className="col-12 text-center">
                <h2 className="title split-collab">Comprehensive Financial & Business Services</h2>
                <p className="disc">
                  AQ Auditing provides end-to-end financial solutions tailored to Bahrain's business landscape. 
                  From accounting and compliance to strategic advisory and business setup, we support organizations 
                  at every stage of their growth journey with expertise and local market knowledge.
                </p>
              </div>
            </div>

            {contentBlocks.map((block, index) => (
              <div
                key={index}
                ref={refs[block.key]}
                className="row align-items-center mb-5"
                data-aos="fade-up"
              >
                {index % 2 === 0 ? (
                  <>
                    <div className="col-lg-6 mb-4 mb-lg-0" data-aos="fade-right">
                      <div className="image-wrapper">
                        <img src={block.img} alt={block.title} className="img-fluid rounded shadow service-img" />
                        <div className="hover-wave"></div>
                      </div>
                    </div>
                    <div className="col-lg-6" data-aos="fade-left">
                      <h3 className="title">{block.title}</h3>
                      <h4 className="subtitle">{block.subtitle}</h4>
                      <p className='description' style={{textAlign:"justify"}}>{block.desc}</p>
                      <ul className="tick-points">
                        {block.points.map((point, i) => (
                          <li key={i}><FaCheckCircle className="tick-icon" /> {point}</li>
                        ))}
                      </ul>
                      <button className="btn-learn" onClick={() => navigate('/Contact')}>
                        Reach Us
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-lg-6 order-lg-2 mb-4 mb-lg-0" data-aos="fade-left">
                      <div className="image-wrapper">
                        <img src={block.img} alt={block.title} className="img-fluid rounded shadow service-img" />
                        <div className="hover-wave"></div>
                      </div>
                    </div>
                    <div className="col-lg-6 order-lg-1" data-aos="fade-right">
                      <h3 className="title">{block.title}</h3>
                      <h4 className="subtitle">{block.subtitle}</h4>
                      <p className='description' style={{textAlign:"justify"}}>{block.desc}</p>
                      <ul className="tick-points">
                        {block.points.map((point, i) => (
                          <li key={i}><FaCheckCircle className="tick-icon" /> {point}</li>
                        ))}
                      </ul>
                      <button className="btn-learn" onClick={() => navigate('/Contact')}>
                        Reach Us
                      </button>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
        <Footer />
      </main>
    </div>
  );
}

export default ServiceDetails;